import {Inject, Injectable} from '@angular/core';
import {AddPatternReturnType} from '@application/command/add-pattern-return-type';
import {Command} from '@application/command/command';
import {PATTERNS, Patterns} from '@infrastructure/http/patterns/patterns';
import {Observable} from 'rxjs';

@Injectable()
export class AddFreeZonePattern implements Command<number, AddPatternReturnType> {
  public constructor(@Inject(PATTERNS) private readonly patterns: Patterns) {}

  public execute(machineQualityId: number): AddPatternReturnType {
    return (name: string, imageData: string): Observable<number> => {
      return this.patterns.saveFreeZonePattern(name, imageData, machineQualityId);
    };
  }
}
